import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import styled from "styled-components";
import { FlexColumnDiv } from "./common.styles";
import { LightText } from "./HXMobilePage.styles";
export const ListContainer = styled(FlexColumnDiv) `
    align-items: flex-start;
    align-self: stretch;
    padding: 0;
    gap: 16px;
`;
export const ListAndRequirements = styled(FlexColumnDiv) `
    align-items: flex-start;
    align-self: stretch;
    gap: 16px;
`;
export const ClearInfoLink = styled.a `
    color: ${colors.blue_main};
    text-decoration: underline;
    cursor: pointer;
`;
export const LegacyClearForwardSecondaryActions = styled(FlexColumnDiv) `
    align-self: stretch;
    gap: 12px;
    margin-top: 12px;
`;
export const LegacyClearForwardPrompt = styled(LightText) `
    text-align: center;
    align-self: stretch;
`;
export const FindRecordOptions = styled(FlexColumnDiv) `
    align-self: stretch;
    gap: 24px;
`;
export const FindRecordOption = styled(FlexColumnDiv) `
    padding: 20px;
    gap: 12px;
    border-radius: 40px;
    border: 1px solid ${colors.blue_30};
    align-items: center;
`;
export const FindRecordOptionTitle = styled(FlexColumnDiv) `
    color: ${colors.black_light};
    font-weight: ${fontWeights.SEMI_BOLD};
    align-self: center;
`;
export const FindRecordOptionText = styled.div `
    color: ${colors.navy_main};
    font-size: ${fontSizes.LITTLE};
    align-self: center;
    text-align: center;
`;
